import moment from 'moment'
import { useTranslation } from 'react-i18next'
import { useGet } from 'src/hooks/useGet'
import { GetAttachRequestEligibility } from 'src/requests/Requests'

const EligibilityInfo = ({ recordID }: { recordID: number | null }) => {

    const { t } = useTranslation()

    const { data: requestEligInfo } = useGet({ API: GetAttachRequestEligibility, isNotValid: !recordID, depArr: [recordID], params: [recordID], defaultValue: null })


    return (
        <>
            {
                requestEligInfo ?
            <div className='request-eligibility-info'>
                <div className='data-title'><span className='info-icon'>!</span> {t('request-eligib')} :-</div>
                <br />
                {//@ts-ignore
                    <div><span className='data-title'>{t("re-number")} : </span> {requestEligInfo?.requestId}</div>}
                {//@ts-ignore
                    <div><span className='data-title'>{t("pack-date")} : </span> {moment(requestEligInfo?.packedDate).format('yyyy-MM-DD')}</div>}
                { //@ts-ignore
                    <div><span className='data-title'>{t("status")} : </span> {requestEligInfo?.status}</div>}
                {//@ts-ignore
                    <div><span className='data-title'>{t("service-fees")} : </span> {requestEligInfo?.serviceFees}</div>}
            </div > : ""
             } 
        </>
    )
}

export default EligibilityInfo